import { css, styled } from "styled-components";

export const RichText = styled.div.attrs({ className: "rich-text" as string })<{
  $centered?: boolean;
}>`
  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: calc(${(props) => props.theme.spacing.xs} / 2);
  }

  h1 + p,
  h2 + p,
  h3 + p,
  h4 + p,
  h5 + p,
  h6 + p {
    margin-top: 0;
  }

  a {
    color: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  figure {
    margin: 0;
    float: none !important;
  }

  figure.align-center {
    display: table;
    margin-left: auto;
    margin-right: auto;
  }

  figcaption {
    margin-top: ${(props) => props.theme.spacing.xs};
    font-style: italic;
  }

  @media (min-width: 650px) {
    figure.align-left {
      float: left !important;
      margin-right: ${(props) => props.theme.spacing.xs};
    }

    figure.align-right {
      float: right !important;
      margin-left: ${(props) => props.theme.spacing.xs};
    }
  }

  ${(props) =>
    props.$centered &&
    css`
      text-align: center;
    `}
`;
